import { render, staticRenderFns } from "./index-mobile.vue?vue&type=template&id=f4991844&scoped=true"
import script from "./index-mobile.vue?vue&type=script&lang=js"
export * from "./index-mobile.vue?vue&type=script&lang=js"
import style0 from "./index-mobile.vue?vue&type=style&index=0&id=f4991844&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4991844",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSvg: require('/builds/wj/fe/wenjuan-homesite/components/common/svg.vue').default,CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default})
